<template>
    <div class="login_b">
        <div class="login_left"></div>
        <div class="login_buttom">
            <div class="login_name">
                <div class="login_name_welcome">欢迎使用</div>
                <div class="login_name_system">易拓国际后台管理系统</div>

            </div>
            <div class="input_box">
                <el-form :model="input" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
                    <el-form-item  prop="number">
                        <el-input v-model="input.number" placeholder="请输入手机号码"></el-input>
                        <img class="icon_img" src="../../assets/icons/user.png" alt="">
                    </el-form-item>
                    <el-form-item  prop="password">
                        <el-input v-model="input.password"  show-password placeholder="请输入密码"></el-input>
                        <img class="icon_img" src="../../assets/icons/password.png" alt="">
                    </el-form-item>
                    <el-form-item  prop="password">
                        
                        <el-button style="width: 100%;background: #2882FE;color: #fff;" @click="login('ruleForm')">登录</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                img:'https://img1.baidu.com/it/u=4049022245,514596079&fm=253&fmt=auto&app=120&f=JPEG?w=889&h=500',
                input:{
                    number:'',
                    password:''
                },
                rules: {
                    number: [
                        { required: true, message: '请输入账号', trigger: 'blur' },
                        { min: 1, max: 11, message: '长度在 1 到 11 个字符', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ],
                },
            }
        },
        methods:{ 
            login(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                         console.log(1515,this.input);
                        let obj={
                            phone:this.input.number,
                            password:this.input.password
                        }
                        this.$http.post('/login/user',obj).then((res)=>{
                            console.log(res);
                            if(res.code==200){
                                sessionStorage.setItem('user_token',res.data.user.token)
                                sessionStorage.setItem('user_menu',JSON.stringify( res.data.menu))
                                sessionStorage.setItem('user',JSON.stringify( res.data.user))
                                sessionStorage.setItem("activePath", '/index');
                                this.$router.push('/index')
                            }else{
                                this.$message({
                                    message:res.message,
                                    type:'error'
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    }
</script>
<style lang="less" scoped>
/deep/.el-input__inner{
    text-indent:20px
}
/deep/.el-input__inner::placeholder {

    position:relative;
    
}
/deep/.el-form-item{
    position: relative;    
    .icon_img{
        position: absolute;
        top: 10px;
        width: 18px;
        height: 18px;
        left: 10px;

    }
}
    .login_b{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        .login_left{
            width: 60%;
            height: 100%;
            background-image: url(../../assets/loginleft.png) ;
            background-repeat: no-repeat;
        }
        .login_buttom{
            width: 30%;
            height: 100%;
            background: #fff;
            .login_name{
                margin-top: 120px;
                margin-left: 106px;
                .login_name_welcome{
                    font-size: 28px;
                    font-weight: 400;
                    color: #666666;
                    line-height: 42px;
                }
                .login_name_system{
                    font-size: 36px;
                    font-weight: 500;
                    color: #2882FE;
                    line-height: 42px;
                }
            }
        }
        .input_box{
            margin-top: 218px;
            margin-left: 106px;
            
        }
    }
</style>